var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0C12.3105 0 0 12.3105 0 27.5C0 42.6895 12.3105 55 27.5 55C42.6895 55 55 42.6895 55 27.5C55 12.3105 42.6895 0 27.5 0ZM44.666 44.6553C42.4316 46.8896 39.8428 48.6406 36.9531 49.8545C33.9668 51.1221 30.7871 51.7559 27.5 51.7559C24.2236 51.7559 21.0439 51.1113 18.0469 49.8545C15.1572 48.6299 12.5576 46.8789 10.334 44.6553C8.09961 42.4209 6.34863 39.832 5.13477 36.9424C3.86719 33.9561 3.22266 30.7764 3.22266 27.5C3.22266 24.2236 3.86719 21.0439 5.12402 18.0469C6.34863 15.1572 8.09961 12.5576 10.3232 10.334C12.5684 8.09961 15.1572 6.34863 18.0469 5.12402C21.0439 3.86719 24.2236 3.22266 27.5 3.22266C30.7764 3.22266 33.9561 3.86719 36.9531 5.12402C39.8428 6.34863 42.4424 8.09961 44.666 10.3232C46.9004 12.5576 48.6514 15.1465 49.8652 18.0361C51.1328 21.0225 51.7666 24.2021 51.7666 27.4893C51.7666 30.7656 51.1221 33.9453 49.8652 36.9424C48.6406 39.832 46.8896 42.4316 44.666 44.6553Z",
    fill: "#5B21FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8086 21.8496H14.4482V39.0049H19.8086V21.8496Z",
    fill: "#5B21FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 13.75C15.0391 13.75 13.7393 15.0283 13.7393 16.7256C13.7393 18.3906 14.9961 19.7012 16.9404 19.7012H16.9834C19.0029 19.7012 20.2598 18.3799 20.249 16.7256C20.2061 15.0283 18.9922 13.75 17.0156 13.75Z",
    fill: "#5B21FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4502 21.6885C31.3779 21.6885 29.4551 23.3643 29.1006 24.5459V21.8496H23.0742C23.1494 23.2783 23.0742 39.0049 23.0742 39.0049H29.1006V29.7344C29.1006 29.208 29.0791 28.6924 29.2295 28.3271C29.6377 27.2959 30.5293 26.2217 32.1299 26.2217C34.2246 26.2217 35.1699 27.8115 35.1699 30.1318V39.0049H41.25V29.4658C41.25 24.1592 38.2637 21.6885 34.4502 21.6885Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink1);
export default __webpack_public_path__ + "static/media/ic-link (1).3af7b61e6ed7b13f8a1088732cc06222.svg";
export { ForwardRef as ReactComponent };